var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// @ts-ignore
import { iconsSvg, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetSteps } from "../../utils/getSteps";
import { PaymentHeader } from "./ui/header";
import { getCustomerAction, isAcap, isAlnap, isApapAuto, } from "../../fnx/customer";
import { policyCreateClearData } from "../../store/policy/actions";
import { dataFilter, paymentSummaryStorybook, } from "./resources/paymentSummaryDto";
import { PaymentSummaryView } from "./ui/view";
import { Customer } from "../../enum/customer";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { quoteOne } from "../../store/generateQuote/actions";
import { personByIdClearData } from "../../store/person/actions";
import { catalogAccountTypeClearData } from "../../store/plan/actions";
import usePaymentSummary from "./components/paymentSummary";
import useUI from "./components/ui";
import useSelectors from "./components/selectors";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { formatToTwoDecimals } from "../../utils/getPrice";
import { addToSummary } from "ah_utility/fnxUtils";
var PaymentSummary = function () {
    var _a, _b, _c;
    var steps2 = useGetSteps();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(""), accountName = _e[0], setAccountName = _e[1];
    var _f = useState(""), accountType = _f[0], setAccountType = _f[1];
    var _g = useState([]), accountList = _g[0], setAccountList = _g[1];
    var _h = useState(""), personId = _h[0], setPersonId = _h[1];
    var _j = useState(""), accountNumber = _j[0], setAccountNumber = _j[1];
    var _k = useState(false), personTrigger = _k[0], setPersonTrigger = _k[1];
    var _l = React.useState([]), steps = _l[0], setSteps = _l[1];
    var _m = useState(""), subTitlePayment = _m[0], setSubTitlePayment = _m[1];
    var _o = useState([]), listAccountTypes = _o[0], setListAccountTypes = _o[1];
    var _p = React.useState([]), breadCrumbs = _p[0], setBreadCrumbs = _p[1];
    var _q = useState({}), dataFormPayment = _q[0], setDataFormPayment = _q[1];
    var _r = React.useState(""), projectId = _r[0], setProjectId = _r[1];
    var _s = useState(false), cardSelected = _s[0], setCardSelected = _s[1];
    var _t = useState(false), nextDisabled = _t[0], setNextDisabled = _t[1];
    var company = findParamInLocalStorage("subdomain");
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quote = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var quoteId = localStorage.getItem("Quote");
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var actionFlags = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.find(function (flag) { return flag.name === "afy-create-policy-pending-status"; });
    // Si encuentra el flag Y su value es "true", retorna true; caso contrario, retorna false
    var createPolicyPendingStatus = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var isTravelInsurance = (_a = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (flag) { return flag.name === "afy-show-plan-travel-range-info"; })) !== null && _a !== void 0 ? _a : false;
    var isOnlyPaymentCreditCard = (_b = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (flag) { return flag.name === "afy-payment-credit-card-only"; })) !== null && _b !== void 0 ? _b : false;
    var planName = (Plan === null || Plan === void 0 ? void 0 : Plan.name) || "";
    var _u = useState([]), paymentListOptions = _u[0], setPaymentListOptions = _u[1];
    var _v = useState({
        id: "",
        name: "",
        option: 0,
    }), paymentListOption = _v[0], setPaymentListOption = _v[1];
    var _w = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _w[0], setSeeToast = _w[1];
    var _x = useState({
        Name: "",
        LastNames: "",
        DocumentNumber: "",
        Email: "",
        Insurance: "",
        PlanTypeName: "",
        CampaignName: "",
        CoverType: "",
        PaymentMode: "",
        Currency: "",
        Prima: "",
        QuoteId: "",
    }), dataForm = _x[0], setDataForm = _x[1];
    var _y = useSelectors(trigger, projectId, personTrigger, personId), responseOneQuote = _y.responseOneQuote, loadingOneQuote = _y.loadingOneQuote, errorOneQuote = _y.errorOneQuote, responsePersonById = _y.responsePersonById, loadingPersonById = _y.loadingPersonById, responseCreatePolicy = _y.responseCreatePolicy, loadingCreatePolicy = _y.loadingCreatePolicy, errorCreatePolicy = _y.errorCreatePolicy, responseCatalogAccountType = _y.responseCatalogAccountType, errorCatalogAccountType = _y.errorCatalogAccountType;
    var _z = usePaymentSummary(dataForm, responseOneQuote, company, accountType, accountName, accountNumber, cardSelected, setSubTitlePayment, setDataFormPayment, setCardSelected, setSeeToast, createPolicyPendingStatus, isOnlyPaymentCreditCard), handleChangePayment = _z.handleChangePayment, createPolicy = _z.createPolicy, loadingComplete = _z.loadingComplete;
    var _0 = useUI(navigate, setAccountType, setAccountNumber, setAccountName, setCardSelected), clickCard = _0.clickCard, handlePrevious = _0.handlePrevious;
    useEffect(function () {
        setTrigger(true);
        dispatch(quoteOne({
            id: quote || quoteId,
            fullBody: true,
        }));
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (responseOneQuote) {
            setDataForm({
                Name: "".concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.firstNameA, " ").concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.firstNameB),
                LastNames: "".concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastNameA, " ").concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastNameB),
                DocumentNumber: responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.numberId,
                Email: responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.email,
                Insurance: (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.productId) === null || _a === void 0 ? void 0 : _a.description,
                PlanTypeName: (_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _b === void 0 ? void 0 : _b.name,
                CampaignName: (_c = responseOneQuote.campaignId) === null || _c === void 0 ? void 0 : _c.name,
                CoverType: (_d = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.coverType) === null || _d === void 0 ? void 0 : _d.description,
                PaymentMode: (_e = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.catalogPaymentMode) === null || _e === void 0 ? void 0 : _e.description,
                Currency: isTravelInsurance
                    ? "USD"
                    : getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                        ? (_f = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _f === void 0 ? void 0 : _f.currencySymbol
                        : (_h = (_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _g === void 0 ? void 0 : _g.price) === null || _h === void 0 ? void 0 : _h.currencySymbol,
                Prima: isTravelInsurance
                    ? ((_j = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.contentMap) === null || _j === void 0 ? void 0 : _j.premium) != null
                        ? "USD ".concat(responseOneQuote.contentMap.premium)
                        : "0.00"
                    : getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                        ? ((_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _k === void 0 ? void 0 : _k.amount)
                            ? formatToTwoDecimals((_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _l === void 0 ? void 0 : _l.amount)
                            : "0.00"
                        : (_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _m === void 0 ? void 0 : _m.price) === null || _o === void 0 ? void 0 : _o.amount,
                QuoteId: responseOneQuote.id,
            });
            setPersonId((_q = (_p = responseOneQuote.insured) === null || _p === void 0 ? void 0 : _p.personId) !== null && _q !== void 0 ? _q : responseOneQuote.personId);
            setPersonTrigger(true);
            setProjectId(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId.projectId);
        }
    }, [responseOneQuote, company]);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a;
        if (isTravelInsurance && ((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.contentMap) === null || _a === void 0 ? void 0 : _a.premium) != null) {
            console.log("Overriding Prima in summary with contentMap.premium:", responseOneQuote.contentMap.premium);
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.contentMap) === null || _c === void 0 ? void 0 : _c.premium]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePersonById === null || responsePersonById === void 0 ? void 0 : responsePersonById.data) {
            setSubTitlePayment("");
            if (getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")) {
                if (!((_b = (_a = responsePersonById.data.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.length)) {
                    showToastSuccessMessage("Este cliente no tiene cuentas activas asociadas para realizar pagos.", typeAlert.info, setSeeToast);
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV4);
                    }
                    else {
                        if (isOnlyPaymentCreditCard) {
                            setSubTitlePayment("No hay cuentas de tarjeta de crédito disponibles para hacer el pago");
                        }
                        else {
                            setSubTitlePayment("No. Recibo de pagos");
                            setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
                            setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV3);
                        }
                    }
                }
                else {
                    var accountListNew = (_c = responsePersonById.data.additionalContentMap) === null || _c === void 0 ? void 0 : _c.accounts.map(function (accounts, idx) { return ({
                        id: idx + 1,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: [accounts.type, accounts.number, accounts.category],
                        iconSvg: iconsSvg.canceledSales,
                    }); });
                    var filteredAccountList = accountListNew.filter(function (account) { return account.cardValues[0] === "CREDIT_CARD"; });
                    if (planName === Customer.FULL ||
                        planName === Customer.AUTO_FULL ||
                        isOnlyPaymentCreditCard) {
                        setAccountList(filteredAccountList);
                    }
                    else {
                        setAccountList(accountListNew);
                    }
                    if (filteredAccountList.length === 0) {
                        setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                    }
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        if (filteredAccountList.length === 0) {
                            setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                        }
                        else {
                            setSubTitlePayment("");
                        }
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV4);
                    }
                    else {
                        setSubTitlePayment("No. Recibo de pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2); /// se cambio por el de v3
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV2);
                    }
                }
            }
            if (isAlnap(company)) {
                setSubTitlePayment("");
                console.log("alnap");
                setListAccountTypes([
                    {
                        id: "1",
                        name: "Cuenta de Ahorro",
                        value: "1",
                    },
                    {
                        id: "2",
                        name: "Cuenta Monetaria",
                        value: "2",
                    },
                ]);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionsAlnap[0]);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsAlnap.map(function (option) { return (__assign(__assign({}, option), { disabled: false })); }));
            }
            if (isAcap(company)) {
                console.log("acap");
                setSubTitlePayment("");
                var mockAccountList = [
                    {
                        id: 1,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["DEBIT", "03102040890", "CHECKING"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 2,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["DEBIT", "05500150833", "SAVINGS"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 3,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["CREDIT_CARD", "40224903282", "Tarjeta de Crédito"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 4,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["CREDIT_CARD", "40238337121", "Tarjeta de Crédito"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                ];
                setAccountList(mockAccountList);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionsAcap[0]);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsAcap.map(function (option) { return (__assign(__assign({}, option), { disabled: false })); }));
            }
            dispatch(personByIdClearData());
        }
    }, [responsePersonById, company]);
    useEffect(function () {
        if (errorCatalogAccountType) {
            showErrorToast(errorCatalogAccountType, setSeeToast, t);
        }
    }, [errorCatalogAccountType]);
    useEffect(function () {
        var _a, _b, _c;
        if (!getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "") &&
            !isAcap(company) &&
            !isAlnap(company)) {
            if (responseCatalogAccountType &&
                ((_a = responseCatalogAccountType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var data = (_b = responseCatalogAccountType.data) === null || _b === void 0 ? void 0 : _b.map(function (account) {
                    var _a;
                    return {
                        id: account.catalogAccountTypeId,
                        value: account.catalogAccountTypeId,
                        name: (_a = account.catalogAccountType) === null || _a === void 0 ? void 0 : _a.description,
                    };
                });
                setListAccountTypes(data);
                dispatch(catalogAccountTypeClearData());
                setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV2);
            }
            else if (responseCatalogAccountType &&
                ((_c = responseCatalogAccountType.data) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV3);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
            }
        }
    }, [responseCatalogAccountType, company]);
    useEffect(function () {
        if (responseCreatePolicy && responseCreatePolicy.data) {
            setNextDisabled(false);
            dispatch(policyCreateClearData());
            dispatch(policyCreateClearData());
        }
    }, [responseCreatePolicy]);
    useEffect(function () {
        if (errorCreatePolicy) {
            showErrorToast(errorCreatePolicy, setSeeToast, t);
            setNextDisabled(true);
        }
    }, [errorCreatePolicy]);
    return (_jsxs(React.Fragment, { children: [_jsx(PaymentHeader, { loading: loadingOneQuote || loadingPersonById || loadingComplete, loadingCreatePolicy: loadingCreatePolicy, breadCrumbs: breadCrumbs, steps: steps2, seeToast: seeToast, setSeeToast: setSeeToast, title: paymentSummaryStorybook.title }), _jsx(PaymentSummaryView, { breadCrumbs: breadCrumbs, steps: steps, seeToast: seeToast, setSeeToast: setSeeToast, accountName: "".concat(dataForm.Name, " ").concat(dataForm.LastNames), nextLabel: paymentSummaryStorybook.nextLabel, options: listAccountTypes, paymentOption: paymentListOption, paymentOptions: paymentListOptions, hideSubTitlePayment: true, subTitlePayment: subTitlePayment, previousLabel: paymentSummaryStorybook.previousLabel, stepProgress: paymentSummaryStorybook.stepProgress, onBack: handlePrevious, filters: dataFilter(dataForm), dataForm: dataForm, onNext: createPolicy, onChangePayment: handleChangePayment, accountList: accountList, onClickCard: clickCard, 
                // voucherMaxLength={isApapAuto(company) ? 12 : 20}
                // voucherMinLength={isApapAuto(company) ? 12 : 1}
                voucherMaxLength: 20, voucherMinLength: 1, voucherIsAlphaNumeric: isApapAuto(company), nextDisabled: nextDisabled, loading: loadingOneQuote || loadingPersonById, loadingCreatePolicy: loadingCreatePolicy })] }));
};
export default PaymentSummary;
